import React from 'react';
import styles from './TextForm.style';

class TextForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: ''};

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.setState({value: this.props.body});
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        const data = {...this.props, body: this.state.value};
        this.props.onSubmit(data)
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <textarea type="text" style={styles.textarea} value={this.state.value} onChange={this.handleChange} />
                <input type="submit" value="Save" />
            </form>
        );
    }
}

export default TextForm